import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Building } from 'lucide-react';
import Button from '../ui/Button';
import { useImpersonation } from '../../context/ImpersonationContext';

const ImpersonationBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isImpersonating, actingTenantId, actingTenantName, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !actingTenantId) {
    return null;
  }

  const handleStopImpersonation = () => {
    stopImpersonation();
    navigate('/admin/dashboard');
  };

  return (
    <div className="w-full bg-amber-500 text-amber-950 px-4 sm:px-6 py-2.5 flex items-center justify-between shadow-md z-50">
      <div className="flex items-center gap-3">
        <Building className="w-5 h-5 flex-shrink-0" />
        <div className="min-w-0">
          <p className="text-sm font-medium truncate">
            Managing: <span className="font-bold">{actingTenantName || actingTenantId}</span>
          </p>
        </div>
      </div>
      
      <Button
        variant="secondary"
        size="sm"
        onClick={handleStopImpersonation}
        className="bg-amber-900 hover:bg-amber-800 text-amber-50 flex-shrink-0 ml-4"
      >
        <LogOut className="w-4 h-4 mr-2" />
        <span className="hidden sm:inline">Exit</span>
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
